(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    (function () {
    function initParallax() {
      const sections = document.querySelectorAll('[data-parallax]');
      if (!sections.length) return;

      function onScroll() {
        sections.forEach(section => {
          const img = section.querySelector('.parallax-image-wrapper img');
          if (!img) return;

          const rect = section.closest('.section').getBoundingClientRect();
          const viewH = window.innerHeight;

          if (rect.bottom < 0 || rect.top > viewH) return;

          const progress = (viewH - rect.top) / (viewH + rect.height);
          const offset = (progress - 0.5) * 60;
          img.style.transform = `translateY(${offset}px)`;
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initParallax);
    } else {
      initParallax();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
